import Echo from 'laravel-echo';
import Pusher from "pusher-js";

declare module '#app' {
  interface NuxtApp {
    $echo: Echo<'pusher'>;
  }
}

declare module 'vue' {
  interface ComponentCustomProperties {
    $echo: Echo<'pusher'>;
  }
}

declare module '@vue/runtime-core' {
  interface ComponentCustomProperties {
    $echo: Echo<'pusher'>;
  }
}

export default defineNuxtPlugin(async (nuxtApp) => {
  const pusherConfig = useRuntimeConfig().public.pusher;
  const {$customFetch} = useNuxtApp()

  if (pusherConfig.enabled === "true") {
    Pusher.logToConsole = pusherConfig.logToConsole === "true";

    const echo = new Echo({
      broadcaster: 'pusher',
      key: pusherConfig.appKey,
      cluster: pusherConfig.cluster,
      forceTLS: true,
      authorizer: (channel: { name: string }) => {
        return {
          authorize: async (socketId: string, callback: Function) => {
            const response = await $customFetch(`/api/broadcasting/auth`, {
              method: 'post',
              body: {
                socket_id: socketId,
                channel_name: channel.name
              },
            })

            callback(null, response);
          }
        };
      },
    });

    nuxtApp.provide('echo', echo)
    nuxtApp.provide('pusher', Pusher)
  }
})
